module.exports = __webpack_public_path__ + "img/thumbnail-lora-media-with-slider.e8d9ac36.webp";